import { HeaderToolbar, Spinner } from "@xola/ui-kit";
import React, { useEffect } from "react";
import { useDebounce } from "use-debounce";
import { useSearchAutoFocus } from "../../hooks/useSearchAutoFocus";
import { usePurchaseSearchStore } from "../../stores/purchaseSearchStore";

interface PurchaseSearchProps {
    onSearchText: (value: string) => void;
    isLoading: boolean;
}

export const PurchaseSearch = ({ isLoading, onSearchText }: PurchaseSearchProps) => {
    const shouldAutoFocus = useSearchAutoFocus();
    const [searchQuery, setSearchQuery] = usePurchaseSearchStore((state) => [state.searchQuery, state.setSearchQuery]);
    const [debouncedSearch] = useDebounce(searchQuery, 500);

    useEffect(() => {
        onSearchText(debouncedSearch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch]);

    return (
        <span className="relative w-2/6 min-w-10">
            <HeaderToolbar.Search
                shouldHideMenu
                autoFocus={shouldAutoFocus}
                defaultValue={searchQuery}
                shouldStayOpen={false}
                isLoading={isLoading}
                autoComplete="off"
                placeholder="Name, email, phone, tag or ID"
                onChange={setSearchQuery}
            />
            {isLoading && <Spinner size="tiny" className="absolute top-1.5 right-4" />}
        </span>
    );
};
